const LS_KEY = 'logos-badges';

// Badge definitions — each has an id, condition check, and tier
const BADGE_DEFS = [
  { id: 'firstSession', icon: '🌱', tier: 'bronze', check: (ctx) => ctx.totalDays >= 1 },
  { id: 'streak3', icon: '🔥', tier: 'bronze', check: (ctx) => ctx.streak >= 3 },
  { id: 'streak7', icon: '🔥', tier: 'silver', check: (ctx) => ctx.streak >= 7 },
  { id: 'streak30', icon: '🔥', tier: 'gold', check: (ctx) => ctx.streak >= 30 },
  { id: 'lambda50', icon: '📡', tier: 'bronze', check: (ctx) => ctx.lambda >= 0.50 },
  { id: 'lambda70', icon: '📡', tier: 'silver', check: (ctx) => ctx.lambda >= 0.70 },
  { id: 'lambda90', icon: '📡', tier: 'gold', check: (ctx) => ctx.lambda >= 0.90 },
  { id: 'allDomains40', icon: '⚖️', tier: 'silver', check: (ctx) => ctx.domainScores && Object.values(ctx.domainScores).every(v => v >= 0.40) },
  { id: 'allDomains60', icon: '⚖️', tier: 'gold', check: (ctx) => ctx.domainScores && Object.values(ctx.domainScores).every(v => v >= 0.60) },
  { id: 'emergence1', icon: '✨', tier: 'silver', check: (ctx) => ctx.emergenceReports >= 1 },
  { id: 'emergence5', icon: '✨', tier: 'gold', check: (ctx) => ctx.emergenceReports >= 5 },
  { id: 'lessonComplete', icon: '📚', tier: 'bronze', check: (ctx) => ctx.lessonsCompleted >= 7 },
];

const TIER_COLORS = {
  bronze: '#CD7F32',
  silver: '#C0C0C0',
  gold: '#FFD700',
};

function getEarnedBadges() {
  try { return JSON.parse(localStorage.getItem(LS_KEY) || '{}'); } catch { return {}; }
}

function saveEarnedBadges(badges) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(badges)); } catch {}
}

export function checkAndAwardBadges(ctx) {
  const earned = getEarnedBadges();
  const newBadges = [];

  for (const def of BADGE_DEFS) {
    if (!earned[def.id] && def.check(ctx)) {
      earned[def.id] = { ts: Date.now(), tier: def.tier };
      newBadges.push(def);
    }
  }

  if (newBadges.length > 0) {
    saveEarnedBadges(earned);
  }

  return newBadges; // Returns only newly earned badges
}

export function getAllBadges() {
  const earned = getEarnedBadges();
  return BADGE_DEFS.map(def => ({
    ...def,
    earned: !!earned[def.id],
    earnedAt: earned[def.id]?.ts || null,
    tierColor: TIER_COLORS[def.tier],
  }));
}

export function getEarnedCount() {
  return Object.keys(getEarnedBadges()).length;
}

export { BADGE_DEFS, TIER_COLORS };
